export default __webpack_public_path__ + "static/media/health_check_table_Cn.874180f2.webp";